export const ns = 'cube3/cookie-consent';
